var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-primary has-icon btn-block mb-2",on:{"click":function () { this$1.$bvModal.show('new-discussion-modal') }}},[_c('i',{staticClass:"fa fa-commenting",attrs:{"aria-hidden":"true"}}),_vm._v("\n    New Forum Post\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }